<div class="comments-container p-4 bg-light rounded">
  <!-- En-tête -->
  <div class="d-flex align-items-center mb-3">
    <i class="ri-message-3-line text-primary fs-4 me-2"></i>
    <h5 class="m-0 fw-bold">{{ comments.length }} commentaire{{ comments.length > 1 ? 's' : '' }}</h5>
  </div>

  <p class="text-muted" *ngIf="comments.length === 0">Aucun commentaire pour l’instant. Soyez le premier à contribuer 💬</p>

  <hr>

  <!-- Zone de saisie avec bouton d’envoi -->
  <div class="comment-input-container mb-3">
    <div class="position-relative w-100">
      <input 
        type="text"
        class="form-control pe-5"
        placeholder="Écris un commentaire..."
        [attr.readonly]="!isLoggedIn ? true : null"
        [class.readonly-style]="!isLoggedIn"
        (click)="handleInputFocus()"
        [(ngModel)]="newCommentText"
        (keydown.enter)="submitRootComment()"
      />
      <button 
        class="send-icon-button"
        (click)="submitRootComment()"
        [disabled]="!newCommentText.trim()"
      >
        <i class="ri-send-plane-2-fill"></i>
      </button>
    </div>
  </div>
  

  <!-- Accordéon pour afficher les commentaires -->
  <button class="btn btn-outline-primary mb-3" (click)="toggleComments()" *ngIf="comments.length > 0">
    {{ showComments ? 'Masquer les commentaires' : 'Voir les commentaires' }}
  </button>

  <div *ngIf="showComments">
    <div *ngFor="let rootComment of displayedRootComments">
      <app-comment
        [comment]="rootComment"
        [replies]="getReplies(rootComment.id)"
        [activeComment]="activeComment"
        (setActiveComment)="setActiveComment($event)"
        (addComment)="addComment($event)"
        (deleteComment)="deleteComment($event)"
        (updateComment)="updateComment($event)"
        [articleId]="articleId"
        (setLike)="onToggleLike($event)"
        [commentType]="commentType"
      ></app-comment>
    </div>
    <div class="text-center mt-2" *ngIf="getRootComments().length > displayedRootComments.length">
      <button class="btn btn-outline-primary" (click)="loadMoreRootComments()">
        Voir {{ getRootComments().length - displayedRootComments.length }} commentaire{{ getRootComments().length - displayedRootComments.length > 1 ? 's' : '' }} supplémentaire{{ getRootComments().length - displayedRootComments.length > 1 ? 's' : '' }}
      </button>
    </div>    
  </div>
</div>
